import React from 'react'
import ColorPicker from '../colorpicker'
import {broadcast, listen, stop_listen, post_gql} from '../../utils'
import {INIT_LINE_SETTINGS} from '../../utils/line_utils'
import './index.css'

class LineTool extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      mode: 'cursor',
      mouse_down_coords: false,
      container_mouse_coords: false,
      edit_layer_id: false,
      top: 10,
      left: 30,
      user_id: false,
      line_settings: INIT_LINE_SETTINGS,
      hidden: false,
      fill_hidden: false,
      border_hidden: false,
      pattern_hidden: false,
      listners: []
    }
  }

  componentDidMount(){
    const listners = [
      {type: "layer_edit", fnc: ({detail}) => {
        if (detail.type === "line")
          this.setState({edit_layer_id: detail.id})
      }},
      {type: "containter_onMouseMove", fnc: ({detail}) => {
        this.setState({container_mouse_coords: [detail.clientX, detail.clientY]})
        if (!!this.state.mouse_down_coords)
          this.setState({
            top: this.state.top + (detail.clientY - this.state.mouse_down_coords[1]),
            left: this.state.left + (detail.clientX - this.state.mouse_down_coords[0]),
            mouse_down_coords: [detail.clientX, detail.clientY]
          })
      }},
      {type: "toolbar_mode_change", fnc: ({detail}) => this.setState({mode: detail.mode, edit_layer_id: false})},
      {type: "set_line_settings", fnc: ({detail}) => this.setState({line_settings: detail})},
      {type: "map_click", fnc: ({detail}) => {
        if (detail.mode === "cursor") {
          const obj = detail.event.object
          if (obj && !obj.bbox && !!obj.properties.line_settings) {
            this.setState({
              edit_layer_id: obj.properties.id,
              line_settings: {...obj.properties.line_settings}
            })
            broadcast("layer_edit", {id: obj.properties.id, type: "line"})
            broadcast("line_settings", {user_id: this.props.user_id, line_settings: obj.properties.line_settings})
          } else {
            if (this.state.object_id)
              this.setState({edit_layer_id: false})
          }
        }
      }},
      {type: "toolbar_delete", fnc: ({detail}) => {
        if (this.state.edit_layer_id) {
          post_gql(
            `mutation {geomapLayerDelete(layer_id: ${this.state.edit_layer_id})}`,
            resp => {
              broadcast("remove_layer", this.state.edit_layer_id)
              broadcast("remove_layer", `${this.state.edit_layer_id}_distance`)
              broadcast("toolbar_mode_change", {mode: 'cursor'})
              broadcast("layer_edit", {id: false, type: "line"})
            }
          )
        }
      }},

      {type: "line_color", fnc: ({detail}) => this.setState({line_settings: {...this.state.line_settings, color: detail.value}})},
      {type: "line_opacity", fnc: ({detail}) => this.setState({line_settings: {...this.state.line_settings, opacity: detail.value}})},
      {type: "line_width", fnc: ({detail}) => this.setState({line_settings: {...this.state.line_settings, width: detail.value}})},
      {type: "line_cap_rounded", fnc: ({detail}) => this.setState({line_settings: {...this.state.line_settings, cap_rounded: detail.value}})},
      {type: "line_joint_rounded", fnc: ({detail}) => this.setState({line_settings: {...this.state.line_settings, joint_rounded: detail.value}})},
      {type: "line_show_points", fnc: ({detail}) => this.setState({line_settings: {...this.state.line_settings, show_points: detail.value}})},
      {type: "line_show_distance", fnc: ({detail}) => this.setState({line_settings: {...this.state.line_settings, show_distance: detail.value}})},

      {type: "update_line_color", fnc: ({detail}) => this.setState({line_settings: {...this.state.line_settings, color: detail.value}})},
      {type: "update_line_opacity", fnc: ({detail}) => this.setState({line_settings: {...this.state.line_settings, opacity: detail.value}})},
      {type: "update_line_width", fnc: ({detail}) => this.setState({line_settings: {...this.state.line_settings, width: detail.value}})},
      {type: "update_line_cap_rounded", fnc: ({detail}) => this.setState({line_settings: {...this.state.line_settings, cap_rounded: detail.value}})},
      {type: "update_line_joint_rounded", fnc: ({detail}) => this.setState({line_settings: {...this.state.line_settings, joint_rounded: detail.value}})},
      {type: "update_line_show_points", fnc: ({detail}) => this.setState({line_settings: {...this.state.line_settings, show_points: detail.value}})},
      {type: "update_line_show_distance", fnc: ({detail}) => this.setState({line_settings: {...this.state.line_settings, show_distance: detail.value}})},
    ]

    listners.forEach(l => listen(l.type, l.fnc))
    this.setState({listners})
  }

  componentWillUnmount(){this.state.listners.forEach(l => stop_listen(l.type, l.fnc))}

  render() {
    if (this.state.mode === 'line' || !!this.state.edit_layer_id){
      const line = this.state.line_settings

      return(
        <div className="polygon-tool" style={{top: this.state.top, left: this.state.left}}>
          <div
            className="tool-header"
            onMouseDown={e => this.setState({mouse_down_coords: this.state.container_mouse_coords})}
            onMouseUp={e => this.setState({mouse_down_coords: false})}
          >
            <span className="tool-header-title">&nbsp;настройки линии</span>
            <div className="tool-header-btns">
              <span
                className="tool-header-btn"
                onClick={() => this.setState({hidden: !this.state.hidden})}
              >{this.state.hidden ? "▾" : "▸"}</span>
              <span
                className="tool-header-btn"
                style={{transform: `rotateZ(45deg)`}}
                onClick={() => {
                  broadcast("toolbar_mode_change", {mode: 'cursor'})
                  broadcast("layer_edit", {id: false, type: "line"})
                }}
              >+</span>
            </div>
          </div>
          {
            this.state.hidden ? null :
            <div className="tool-body">
              <div>
                <div className="tool-input-cont">
                  <ColorPicker user_id={this.props.user_id} object_id={this.state.edit_layer_id} broadcast_type={!!this.state.edit_layer_id ? "update_line_color" : "line_color"}/>
                </div>
                <div className="tool-input-cont">
                  <span className="tool-input-label">цвет</span>
                  <input
                    className="tool-input"
                    value={line.color}
                    style={{backgroundColor: line.color, color: 'white', textShadow: '0px 0px 4px black'}}
                    onChange={e => broadcast(!!this.state.edit_layer_id ? "update_line_color" : "line_color", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: e.currentTarget.value})}
                  />
                </div>
                <div className="tool-input-cont">
                  <span className="tool-input-label">прозрачность</span>
                  <input
                    className="tool-input"
                    value={line.opacity}
                    onChange={e => broadcast(!!this.state.edit_layer_id ? "update_line_opacity" : "line_opacity", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                  />
                </div>
                <div className="tool-input-cont">
                  <span className="tool-input-label">толщина</span>
                  <input
                    className="tool-input"
                    value={line.width}
                    onChange={e => broadcast(!!this.state.edit_layer_id ? "update_line_width" : "line_width", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: parseInt(e.currentTarget.value) || 0})}
                  />
                </div>

                <div className="tool-input-cont">
                  <span className="tool-input-label">закругление краев</span>
                  <input
                    type="checkbox"
                    className="tool-input"
                    checked={line.cap_rounded}
                    onChange={e => broadcast(!!this.state.edit_layer_id ? "update_line_cap_rounded" : "line_cap_rounded", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: !line.cap_rounded})}
                  />
                </div>

                <div className="tool-input-cont">
                  <span className="tool-input-label">закругление углов</span>
                  <input
                    type="checkbox"
                    className="tool-input"
                    checked={line.joint_rounded}
                    onChange={e => broadcast(!!this.state.edit_layer_id ? "update_line_joint_rounded" : "line_joint_rounded", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: !line.joint_rounded})}
                  />
                </div>

                {null && <div className="tool-input-cont">
                  <span className="tool-input-label">показать точки</span>
                  <input
                    type="checkbox"
                    className="tool-input"
                    checked={line.show_points}
                    onChange={e => broadcast(!!this.state.edit_layer_id ? "update_line_show_points" : "line_show_points", {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: !line.show_points})}
                  />
                </div>}

                <div className="tool-input-cont">
                  <span className="tool-input-label">показать длинну</span>
                  <input
                    type="checkbox"
                    className="tool-input"
                    checked={line.show_distance}
                    onChange={e => {
                      const show = !line.show_distance

                      broadcast(
                        !!this.state.edit_layer_id ? "update_line_show_distance" : "line_show_distance",
                        {object_id: this.state.edit_layer_id, user_id: this.props.user_id, value: show}
                      )
                    }}
                  />
                </div>
              </div>
            </div>
          }
        </div>
      )
    } else {
      return(null)
    }
  }
}

export default LineTool;
